// Google Analytics 4 helpers — no-op safely when REACT_APP_GA_ID is not set.
// Docs: https://developers.google.com/analytics/devguides/collection/ga4/events
const MEASUREMENT_ID = process.env.REACT_APP_GA_ID;
const ENABLED = Boolean(MEASUREMENT_ID && MEASUREMENT_ID.startsWith("G-"));

function safeGtag(...args) {
  if (!ENABLED) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch (e) {
    // fail silently — analytics must never break the app
  }
}

export function trackPageView(path, title) {
  const pageTitle = title || (typeof document !== "undefined" ? document.title : "");
  const pageLocation = typeof window !== "undefined" ? window.location.origin + path : path;
  const pageReferrer = typeof document !== "undefined" ? document.referrer : "";
  safeGtag("event", "page_view", {
    page_title: pageTitle,
    page_location: pageLocation,
    page_path: path,
    page_referrer: pageReferrer || undefined,
  });
}

export function trackEvent(name, params = {}) {
  safeGtag("event", name, {
    event_category: params.category || "engagement",
    ...params,
  });
}

// Named event helpers used across the app
export const track = {
  waitlistSignup: (lang) => trackEvent("waitlist_signup", { category: "conversion", lang }),
  chatMessage: (lang) => trackEvent("chat_message_sent", { category: "engagement", lang }),
  moodSaved: (hasEmotions) => trackEvent("mood_saved", { category: "engagement", has_emotions: !!hasEmotions }),
  worryDropped: () => trackEvent("worry_dropped", { category: "engagement" }),
  winShared: () => trackEvent("win_shared", { category: "engagement" }),
  insightGenerated: (lang) => trackEvent("insight_generated", { category: "engagement", lang }),
  pdfDownloaded: (lang) => trackEvent("pdf_report_downloaded", { category: "engagement", lang }),
  sosOpened: () => trackEvent("sos_opened", { category: "engagement" }),
  langSwitched: (lang) => trackEvent("lang_switched", { category: "engagement", lang }),
};
